import { useState } from 'react'
import type { Optimization } from '../lib/types'
import { ActionCard } from './ActionCard'
import { ManagerActionForm } from './ManagerActionForm'

export function OptimizationChecklist({
  optimizations,
  reportId,
  clientId,
  portalEnabled,
  canAddManagerAction,
}: {
  optimizations: Optimization[]
  reportId: string
  clientId: string
  portalEnabled: boolean
  // Só em relatório pronto (rascunho ou publicado).
  canAddManagerAction: boolean
}) {
  const [adding, setAdding] = useState(false)
  const fromAi = optimizations.filter((o) => o.origin !== 'manager')
  const fromManager = optimizations.filter((o) => o.origin === 'manager')
  // "Registrada" é da AÇÃO: o status é único, vale para todos.
  const registered = fromAi.filter((o) => o.state.status !== 'pending').length

  return (
    <div className="space-y-6">
      <section className="rounded-xl border border-slate-200 bg-slate-50/60 p-5">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-bold text-slate-900">Ações de Otimização</h2>
          <span className="text-sm text-slate-500">
            {registered} de {fromAi.length} registradas
          </span>
        </div>
        <div className="space-y-3">
          {fromAi.map((o) => (
            <ActionCard key={o.id} action={o} kind="optimization" reportId={reportId} />
          ))}
          {fromAi.length === 0 && <p className="text-sm text-slate-500">Nenhuma ação de otimização gerada.</p>}
        </div>
      </section>

      <section className="rounded-xl border border-sky-200 bg-sky-50/40 p-5">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0 max-w-2xl">
            <h2 className="text-lg font-bold text-slate-900">Ações do gerente</h2>
            <p className="mt-0.5 text-sm text-slate-600">
              O que você fez na conta por conta própria, fora das sugestões da IA. A IA lê no próximo relatório, o impacto
              é medido e, feita, a ação aparece no portal do cliente.
            </p>
          </div>
          {canAddManagerAction && !adding && (
            <button
              type="button"
              onClick={() => setAdding(true)}
              className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-sky-700 px-3 py-1.5 text-sm font-medium text-white hover:bg-sky-800"
            >
              <span aria-hidden="true">+</span> Registrar uma ação
            </button>
          )}
        </div>
        <div className="mt-4 space-y-3">
          {adding && <ManagerActionForm reportId={reportId} portalEnabled={portalEnabled} onDone={() => setAdding(false)} />}
          {fromManager.map((o) => (
            <ActionCard key={o.id} action={o} kind="optimization" reportId={reportId} clientId={clientId} />
          ))}
          {fromManager.length === 0 && !adding && (
            <p className="text-sm text-slate-500">
              {canAddManagerAction
                ? 'Nenhuma ação registrada nesta semana. Mexeu em algo que a IA não sugeriu? Registre aqui.'
                : 'Dá para registrar ações quando o relatório terminar de ser gerado.'}
            </p>
          )}
        </div>
      </section>
    </div>
  )
}
